import { render, staticRenderFns } from "./RoundedIcon.vue?vue&type=template&id=3b0f667e&"
import script from "./RoundedIcon.vue?vue&type=script&lang=js&"
export * from "./RoundedIcon.vue?vue&type=script&lang=js&"
import style0 from "./RoundedIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports